import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import TaskHeader from './TaskHeader';
import CircularReviewProgress from './CircularReviewProgress';
import { ChevronRightRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { useLogUserActionMutation } from '../../../api/packSlice';

function ReviewPacksTask(props) {
    const theme = useTheme();
    const navigate = useNavigate();
    const params = useParams();
    const [submitUserAction] = useLogUserActionMutation();

    const reviewedPacks = props.submittedPacks || 0;
    const totalPacks = props.totalPacks || 0;

    const navigateToPacks = async () => {
        // Log entry into packs
        submitUserAction({
            action: 'entry_into_packs',
            data: { physicianId: props.cardOwner.id, campaignId: Number(params.campaignId) }
        }).unwrap().catch(err => console.error('Failed to log user action:', err));
        navigate(`/physician/${props.cardOwner.id}/packs`, { state: {
            campaignId : params.campaignId
        }});
    };

    if (totalPacks > 0) {
        return (
            <Stack spacing={2}>
                <TaskHeader title='Review Packs' taskCount={totalPacks - reviewedPacks} shouldShowCount={reviewedPacks > 0} />
                <Box p={2} className='pendo-review-packs-task' onClick={navigateToPacks} sx={{ boxShadow: 2, borderRadius: '4px', background: `${theme.palette.background.white}` }}>
                    <Stack direction='row' alignItems='center' spacing={2}>
                        <Stack direction='row' alignItems='center' spacing={1}>
                            <CircularReviewProgress value={totalPacks > 0 ? Math.round((reviewedPacks / totalPacks) * 100) : 0} />
                            <Typography variant='light' sx={{ fontSize: '12px' }}>
                                {reviewedPacks} of {totalPacks} packs reviewed
                            </Typography>
                        </Stack>
                        <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ width: '100%' }}>
                            <Typography variant='normal' sx={{ fontSize: '12px' }}>
                                Eliminate waste by providing feedback on the contents of your packs.
                            </Typography>
                            <ChevronRightRounded sx={{ opacity: '0.6' }}/>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        );
    }

    return <></>;
}

export default ReviewPacksTask;